import { useState } from 'react';
import type { IdentityProviderAPI } from '../../../types/identityProvider';
import IdentityProviderDetail from './IdentityProviderDetail';
import IdentityProvidersList from './IdentityProvidersList';

const IdentityProviders = () => {
    const [itemToEdit, setItemToEdit] = useState<IdentityProviderAPI | null>(null);

    return (
        <div className="page-wrapper">
            {itemToEdit === null ? (
                <IdentityProvidersList setItemToEdit={setItemToEdit} />
            ) : (
                <IdentityProviderDetail
                    itemToEdit={itemToEdit}
                    returnToList={() => setItemToEdit(null)}
                />
            )}
        </div>
    );
};

export default IdentityProviders;
